import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getWelcomeEmailLogs, resendWelcomeEmail } from "./_welcomeEmailLogsAction";

interface WelcomeEmailLog {
  _id: string;
  email: string;
  password: string;
  isSent: boolean;
  createdAt: string;
  updatedAt: string;
}

interface WelcomeEmailLogsState {
  data: WelcomeEmailLog[];
  totalRecord: number;
  currentPage: number;
  totalPages: number;
  search: string;
  statusFilter: string;
  isLoading: boolean;
  isSuccess: boolean;
  responseCode: number | null;
  responseMessage: string;
  errorMessage: string;
}

const initialState: WelcomeEmailLogsState = {
  data: [],
  totalRecord: 0,
  currentPage: 1,
  totalPages: 1,
  search: "",
  statusFilter: "",
  isLoading: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  errorMessage: ''
};

export const welcomeEmailLogsList = createSlice({
  name: "welcomeEmailLogsList",
  initialState: initialState,
  reducers: {
    setWelcomeEmailStatusFilter: (state, action: PayloadAction<string>) => {
      state.statusFilter = action.payload;
    },
    setWelcomeEmailSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      // Get Welcome Email Logs
      .addCase(getWelcomeEmailLogs.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getWelcomeEmailLogs.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.logs || [];
        state.totalRecord = payload.data.pagination.total || 0;
        state.currentPage = payload.data.pagination.page || 1;
        state.totalPages = payload.data.pagination.pages || 1;
        if (payload._filters) {
          state.search = payload._filters.search ?? state.search;
          state.statusFilter = payload._filters.status ?? state.statusFilter;
        }
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || '';
      })
      .addCase(getWelcomeEmailLogs.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      })
      
      // Resend Welcome Email
      .addCase(resendWelcomeEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendWelcomeEmail.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || '';
      })
      .addCase(resendWelcomeEmail.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      });
  },
});

export const { setWelcomeEmailStatusFilter, setWelcomeEmailSearch } =
  welcomeEmailLogsList.actions;
